import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <p>Copyright © Designed & Developed by *astTECS {year}</p>
    </footer>
  );
};

export default Footer; 
